/**
 * @file useShipmentAttentionCount.ts
 * @description Счётчик зависших отправлений для бейджей (phase19.13 шаг 5).
 *
 * Число нужно в двух местах — в меню магазина и в шапке реестра заказов.
 * Логика одна, поэтому живёт здесь: ошибку глушим (сеть, гонка контекста),
 * счётчик просто остаётся нулевым и бейдж не рисуется. Меню не должно падать
 * из-за необязательного числа.
 *
 * Права проверяются ДО запроса (phase19.24 этап 0, находка ui-visual-qa):
 * хук висит в `ShopLayout`, то есть отрабатывает на КАЖДОМ экране магазина, и
 * у роли без доступа к заказам (кладовщик) исправно давал 403 в консоли на
 * каждой странице. «Поймали и проглотили» тут не годится: 403 уходит в логи
 * сервера и мусорит консоль. Условие зеркалит серверный guard
 * `ShipmentAttentionService.requireView` — VIEW ИЛИ MANAGE.
 */

import { useEffect, useState } from "react";

import { useHasPermission } from "../auth/hooks";
import { listShipmentsAttention } from "../lib/api-delivery-monitoring";

export function useShipmentAttentionCount(): number {
  const canViewOrders = useHasPermission("SHOP_VIEW_ORDERS");
  const canManageOrders = useHasPermission("SHOP_MANAGE_ORDERS");
  const allowed = canViewOrders || canManageOrders;
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!allowed) {
      setCount(0);
      return;
    }
    let alive = true;
    listShipmentsAttention()
      .then((res) => {
        if (alive) setCount(res.counts.total);
      })
      .catch(() => {
        if (alive) setCount(0);
      });
    return () => {
      alive = false;
    };
  }, [allowed]);

  return count;
}
